// Copyright 2017 Sorama B.V.

import { MeasurementPartType } from "datatypes/SoramaWebApi";

export class MeasurementPartTypeExtensions {
    public static toFileName(measurementPartType: MeasurementPartType): string {
        switch (measurementPartType) {
            case MeasurementPartType.Audio:
                return "sound";
            case MeasurementPartType.Video:
                return "video";
            default:
                throw new Error("Invalid Measurement Part Type");
        }
    }

    public static fromFileName(fileName: string): MeasurementPartType {
        const lcaseFileName = fileName.toLowerCase();
        if (lcaseFileName === "sound") return MeasurementPartType.Audio;

        if (lcaseFileName === "video") return MeasurementPartType.Video;

        throw new Error("Invalid Measurement Part Type");
    }
}
